// Reusable component for showing audit history of a resource

import React from "react";
import ResourceAuditDialog from "../components/dialogs/ResourceAuditDialog";
import { useResourceAuditDialog } from "../hooks/useResourceAuditDialog";
import { MdHistory } from "react-icons/md";

interface AuditHistoryButtonProps {
  resourceId: string;
  resourceName?: string;
  count?: number;
  iconClassName?: string;
  size?: number;
  title?: string;
}

const AuditHistoryButton: React.FC<AuditHistoryButtonProps> = ({
  resourceId,
  resourceName,
  count = 10,
  iconClassName = "cursor-pointer",
  size = 20,
  title = "View Audit",
}) => {
  const { isOpen, openDialog, closeDialog } = useResourceAuditDialog();

  const handleViewAudit = () => {
    openDialog(resourceId, resourceName);
  };

  return (
    <span className="">
      <MdHistory
        size={size}
        color="#6B6B68"
        className={`inline-block align-middle ${iconClassName}`}
        onClick={handleViewAudit}
        title={title}
        style={{ display: "inline-block", verticalAlign: "middle" }}
      />

      <ResourceAuditDialog
        resourceId={resourceId}
        isOpen={isOpen}
        onClose={closeDialog}
        resourceName={resourceName}
        count={count}
      />
    </span>
  );
};

export default AuditHistoryButton;
